// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-bucket-list {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
}

.stock-bucket-list h2 {
  margin: 0 0 16px;
  font-size: 1.125rem;
  color: #1a1a2e;
}

.stock-bucket-list .bucket-card {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;
}

.stock-bucket-list .bucket-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f9fafb;
  cursor: pointer;
}

.stock-bucket-list .bucket-header:hover {
  background: #f3f4f6;
}

.stock-bucket-list .bucket-title {
  font-weight: 600;
  font-size: 0.95rem;
}

.stock-bucket-list .bucket-actions {
  display: flex;
  gap: 6px;
}

.stock-bucket-list .bucket-body {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
}

.stock-bucket-list .edit-row {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  align-items: flex-end;
}

.stock-bucket-list .edit-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stock-bucket-list .edit-group label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
}

.stock-bucket-list .edit-group input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.875rem;
}

.stock-bucket-list .btn-sm {
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  color: #fff;
}

.stock-bucket-list .btn-edit {
  background: #f59e0b;
}

.stock-bucket-list .btn-edit:hover {
  background: #d97706;
}

.stock-bucket-list .btn-delete {
  background: #dc2626;
}

.stock-bucket-list .btn-delete:hover {
  background: #b91c1c;
}

.stock-bucket-list .btn-update {
  background: #2563eb;
}

.stock-bucket-list .btn-update:hover {
  background: #1d4ed8;
}

.stock-bucket-list .btn-cancel {
  background: #6b7280;
}

.stock-bucket-list .btn-cancel:hover {
  background: #4b5563;
}

.stock-bucket-list .items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  margin-top: 8px;
}

.stock-bucket-list .items-table th,
.stock-bucket-list .items-table td {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #e5e7eb;
}

.stock-bucket-list .items-table th {
  background: #f3f4f6;
  font-weight: 600;
}

.stock-bucket-list .add-items-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.stock-bucket-list .add-items-section h4 {
  margin: 0 0 8px;
  font-size: 0.875rem;
}

.stock-bucket-list .no-buckets {
  color: #6b7280;
  font-size: 0.9rem;
}

.stock-bucket-list .loading {
  color: #6b7280;
  font-size: 0.9rem;
}

.stock-bucket-list .warehouse-group {
  margin-bottom: 24px;
}

.stock-bucket-list .warehouse-group-header {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a2e;
  padding: 8px 12px;
  background: #e0e7ff;
  border-radius: 6px;
  border-left: 4px solid #4f46e5;
}

.stock-bucket-list .unassigned-header {
  background: #fef3c7;
  border-left-color: #f59e0b;
  color: #92400e;
}

.stock-bucket-list .warehouse-select {
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.8rem;
  background: #fff;
  cursor: pointer;
}

.stock-bucket-list .standalone-items-section {
  margin-top: 12px;
}

.stock-bucket-list .standalone-header {
  margin: 0 0 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #4b5563;
}

.stock-bucket-list .inline-min-stock {
  width: 70px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.8rem;
  text-align: center;
}

.stock-bucket-list .inline-min-stock:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.stock-bucket-list .min-stock-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/StockBucketList.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".stock-bucket-list {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.stock-bucket-list h2 {\n  margin: 0 0 16px;\n  font-size: 1.125rem;\n  color: #1a1a2e;\n}\n\n.stock-bucket-list .bucket-card {\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\n.stock-bucket-list .bucket-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #f9fafb;\n  cursor: pointer;\n}\n\n.stock-bucket-list .bucket-header:hover {\n  background: #f3f4f6;\n}\n\n.stock-bucket-list .bucket-title {\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.stock-bucket-list .bucket-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.stock-bucket-list .bucket-body {\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.stock-bucket-list .edit-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.stock-bucket-list .edit-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stock-bucket-list .edit-group label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.stock-bucket-list .edit-group input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.875rem;\n}\n\n.stock-bucket-list .btn-sm {\n  padding: 4px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: #fff;\n}\n\n.stock-bucket-list .btn-edit {\n  background: #f59e0b;\n}\n\n.stock-bucket-list .btn-edit:hover {\n  background: #d97706;\n}\n\n.stock-bucket-list .btn-delete {\n  background: #dc2626;\n}\n\n.stock-bucket-list .btn-delete:hover {\n  background: #b91c1c;\n}\n\n.stock-bucket-list .btn-update {\n  background: #2563eb;\n}\n\n.stock-bucket-list .btn-update:hover {\n  background: #1d4ed8;\n}\n\n.stock-bucket-list .btn-cancel {\n  background: #6b7280;\n}\n\n.stock-bucket-list .btn-cancel:hover {\n  background: #4b5563;\n}\n\n.stock-bucket-list .items-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n  margin-top: 8px;\n}\n\n.stock-bucket-list .items-table th,\n.stock-bucket-list .items-table td {\n  text-align: left;\n  padding: 6px 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.stock-bucket-list .items-table th {\n  background: #f3f4f6;\n  font-weight: 600;\n}\n\n.stock-bucket-list .add-items-section {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.stock-bucket-list .add-items-section h4 {\n  margin: 0 0 8px;\n  font-size: 0.875rem;\n}\n\n.stock-bucket-list .no-buckets {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.stock-bucket-list .loading {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.stock-bucket-list .warehouse-group {\n  margin-bottom: 24px;\n}\n\n.stock-bucket-list .warehouse-group-header {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1a1a2e;\n  padding: 8px 12px;\n  background: #e0e7ff;\n  border-radius: 6px;\n  border-left: 4px solid #4f46e5;\n}\n\n.stock-bucket-list .unassigned-header {\n  background: #fef3c7;\n  border-left-color: #f59e0b;\n  color: #92400e;\n}\n\n.stock-bucket-list .warehouse-select {\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  background: #fff;\n  cursor: pointer;\n}\n\n.stock-bucket-list .standalone-items-section {\n  margin-top: 12px;\n}\n\n.stock-bucket-list .standalone-header {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #4b5563;\n}\n\n.stock-bucket-list .inline-min-stock {\n  width: 70px;\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.stock-bucket-list .inline-min-stock:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);\n}\n\n.stock-bucket-list .min-stock-inline {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
